// extracted by mini-css-extract-plugin
export default {"link":"Notification_link__De2QL"};